"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Batch = exports.getBalance = exports.getAccountInfoPayload = exports.batchRpcRequest = void 0;
const pyth_1 = require("./pyth");
const node_fetch_1 = __importDefault(require("node-fetch"));
const getPDA_1 = require("./getPDA");
const states_1 = require("./states/");
function batchRpcRequest(endpoint, body) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield (0, node_fetch_1.default)(endpoint, {
            method: "post",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
        });
        if (res.ok) {
            const data = yield res.json();
            return data;
        }
        else {
            throw new Error('Failed to fetch rpc request batched');
        }
    });
}
exports.batchRpcRequest = batchRpcRequest;
function getAccountInfoPayload(address, index, commitment) {
    return {
        jsonrpc: "2.0",
        id: index,
        method: "getAccountInfo",
        params: [
            address.toBase58(),
            {
                "commitment": commitment,
                "encoding": "jsonParsed"
            }
        ],
    };
}
exports.getAccountInfoPayload = getAccountInfoPayload;
function getBalance(address, index, commitment) {
    return {
        jsonrpc: "2.0",
        id: index,
        method: "getBalance",
        params: [
            address.toBase58(),
            {
                "commitment": commitment,
            }
        ]
    };
}
exports.getBalance = getBalance;
;
;
class Batch {
    constructor(program, rpcUrl, user, commitment = 'processed') {
        this.program = program;
        this.rpcUrl = rpcUrl;
        this.user = user;
        this.commitment = commitment;
    }
    getAllData(gameStates) {
        return __awaiter(this, void 0, void 0, function* () {
            const { balance, data } = yield this.gameStatesAndPlayerBetList(gameStates);
            const roundsDataParams = data.map((item) => {
                var _a;
                return ({
                    gameState: item.gameState,
                    currentRound: item.gameStateData.currentRound,
                    historyItems: ((_a = item.playerBetHistory) === null || _a === void 0 ? void 0 : _a.rounds) || []
                });
            });
            const roundsData = yield this.roundsData(roundsDataParams);
            const result = data.map((item, index) => {
                return Object.assign(Object.assign({ price: 0 }, item), roundsData[index]);
            });
            return {
                balance,
                gameStates: result,
            };
        });
    }
    convertFullDataSerializable(fullData) {
        return fullData.map((gameState) => {
            return {
                price: gameState.price,
                playerBetHistory: gameState.playerBetHistory && (0, states_1.convertPlayerBetHistoryToSerializable)(gameState.playerBetHistory),
                historyItems: gameState.historyItems.map(states_1.convertPlayerBetStateToSerializable),
                gameState: gameState.gameState.toString(),
                gameStateData: (0, states_1.convertGameStateToSerializable)(gameState.gameStateData),
                rounds: gameState.rounds.map(states_1.convertRoundStateToSerializable)
            };
        });
    }
    gameStatesAndPlayerBetList(gameStates) {
        return __awaiter(this, void 0, void 0, function* () {
            const requests = [];
            if (this.user) {
                requests.push(getBalance(this.user, 0, this.commitment));
            }
            const gameStateRequests = gameStates.map((gameState, index) => getAccountInfoPayload(gameState, index + 1, this.commitment));
            requests.push(...gameStateRequests);
            if (this.user) {
                const playerBetHistoryRequests = yield Promise.all(gameStates.map((gameState, index) => __awaiter(this, void 0, void 0, function* () {
                    const [playerBetHistory] = yield (0, getPDA_1.getPDA)(this.program, this.user, gameState);
                    return getAccountInfoPayload(playerBetHistory, index + gameStates.length + 1, this.commitment);
                })));
                requests.push(...playerBetHistoryRequests);
            }
            const batchedValues = yield batchRpcRequest(this.rpcUrl, requests);
            const results = [];
            const balance = this.user ? batchedValues.shift().result.value : 0;
            for (let i = 0; i < gameStates.length; i++) {
                const gameStateItem = batchedValues[i].result.value;
                const gameStateData = this.program.coder.accounts.decode('GameState', Buffer.from(gameStateItem.data[0], 'base64'));
                let playerBetHistory = null;
                if (this.user) {
                    const playerBetHistoryItem = batchedValues[i + gameStates.length].result.value;
                    if (playerBetHistoryItem) {
                        playerBetHistory = this.program.coder.accounts.decode('PlayerBetHistory', Buffer.from(playerBetHistoryItem.data[0], 'base64'));
                        playerBetHistory.rounds = playerBetHistory.rounds.filter((rounds) => !!rounds);
                    }
                }
                results.push({
                    gameState: gameStates[i],
                    gameStateData: gameStateData,
                    playerBetHistory: playerBetHistory,
                });
            }
            return {
                balance,
                data: results,
            };
        });
    }
    _fillRounds(round, otherRounds) {
        let rounds = [...otherRounds, round, round + 1];
        rounds.unshift(round - 1);
        rounds.unshift(round - 2);
        rounds.unshift(round - 3);
        // Rounds should be greater than 0
        return [...new Set(rounds)].filter((num) => num > 0);
    }
    roundsData(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const requests = [];
            let index = 0;
            for (let i = 0; i < params.length; i++) {
                const { gameState, currentRound, historyItems } = params[i];
                let roundsData = this._fillRounds(currentRound, historyItems);
                for (let j = 0; j < roundsData.length; j++) {
                    const round = roundsData[j];
                    const [pda] = yield (0, getPDA_1.getPDA)(this.program, gameState, round.toString());
                    requests.push(getAccountInfoPayload(pda, index, this.commitment));
                    index++;
                }
                if (historyItems) {
                    for (let j = 0; j < historyItems.length; j++) {
                        const playerRound = historyItems[j];
                        const [playerRoundState] = yield (0, getPDA_1.getPDA)(this.program, this.user, gameState, playerRound.toString());
                        requests.push(getAccountInfoPayload(playerRoundState, index, this.commitment));
                        index++;
                    }
                }
            }
            const batchedValues = yield batchRpcRequest(this.rpcUrl, requests);
            const results = [];
            index = 0;
            for (let i = 0; i < params.length; i++) {
                const { currentRound, historyItems } = params[i];
                let roundsData = this._fillRounds(currentRound, historyItems);
                const roundsDataResult = [];
                for (let j = 0; j < roundsData.length; j++) {
                    const rawData = batchedValues[index].result.value;
                    const data = this.program.coder.accounts.decode('RoundState', Buffer.from(rawData.data[0], 'base64'));
                    roundsDataResult.push(data);
                    index++;
                }
                const historyItemsResult = [];
                if (historyItems) {
                    for (let j = 0; j < historyItems.length; j++) {
                        const rawData = batchedValues[index].result.value;
                        const data = this.program.coder.accounts.decode('PlayerBet', Buffer.from(rawData.data[0], 'base64'));
                        historyItemsResult.push(data);
                        index++;
                    }
                }
                results.push({
                    rounds: roundsDataResult,
                    historyItems: historyItemsResult
                });
            }
            return results;
        });
    }
    latest(gameStates) {
        return __awaiter(this, void 0, void 0, function* () {
            const requests = [];
            if (this.user) {
                requests.push(getBalance(this.user, 0, this.commitment));
            }
            for (let i = 0; i < gameStates.length; i++) {
                const gameState = gameStates[i];
                const [currentRound] = yield (0, getPDA_1.getPDA)(this.program, gameState.pubkey, gameState.currentRound.toString());
                const [nextRound] = yield (0, getPDA_1.getPDA)(this.program, gameState.pubkey, (gameState.currentRound + 1).toString());
                requests.push(getAccountInfoPayload(gameState.pubkey, i * 4, this.commitment));
                requests.push(getAccountInfoPayload(gameState.oracleAccount, i * 4 + 1, this.commitment));
                requests.push(getAccountInfoPayload(currentRound, i * 4 + 2, this.commitment));
                requests.push(getAccountInfoPayload(nextRound, i * 4 + 3, this.commitment));
            }
            const batchedValues = yield batchRpcRequest(this.rpcUrl, requests);
            const balance = this.user ? batchedValues.shift().result.value : 0;
            let results = [];
            for (let i = 0; i < gameStates.length; i++) {
                const { pubkey } = gameStates[i];
                const gameStateRawData = batchedValues[i * 4].result.value;
                const oracleRawData = batchedValues[i * 4 + 1].result.value;
                const currentRoundRawData = batchedValues[i * 4 + 2].result.value;
                const nextRoundRawData = batchedValues[i * 4 + 3].result.value;
                const dataBuffer = Buffer.from(oracleRawData.data[0], 'base64');
                const result = {
                    gameState: pubkey,
                    gameStateData: gameStateRawData && this.program.coder.accounts.decode('GameState', Buffer.from(gameStateRawData.data[0], 'base64')),
                    oracleData: (0, pyth_1.parsePriceData)(dataBuffer),
                    currentRound: currentRoundRawData && this.program.coder.accounts.decode('RoundState', Buffer.from(currentRoundRawData.data[0], 'base64')),
                    nextRound: nextRoundRawData && this.program.coder.accounts.decode('RoundState', Buffer.from(nextRoundRawData.data[0], 'base64'))
                };
                results.push(result);
            }
            return {
                balance: balance,
                latest: results
            };
        });
    }
    convertLatestSerializable({ gameState, gameStateData, oracleData, currentRound, nextRound }) {
        return {
            gameState: gameState.toBase58(),
            gameStateData: (0, states_1.convertGameStateToSerializable)(gameStateData),
            oracleData: {
                price: oracleData.price,
                exponent: oracleData.exponent
            },
            currentRound: currentRound && (0, states_1.convertRoundStateToSerializable)(currentRound),
            nextRound: nextRound && (0, states_1.convertRoundStateToSerializable)(nextRound)
        };
    }
    getRoundData(gameStatePubKey, startRound, endRound) {
        return __awaiter(this, void 0, void 0, function* () {
            let roundAccounts = [];
            for (let i = startRound; i <= endRound; i++) {
                const [roundAccount] = yield (0, getPDA_1.getPDA)(this.program, gameStatePubKey, i.toString());
                roundAccounts.push(roundAccount);
            }
            const requests = roundAccounts.map((round, index) => {
                return getAccountInfoPayload(round, index, this.commitment);
            });
            const batchedValues = yield batchRpcRequest(this.rpcUrl, requests);
            return batchedValues.map((rawData) => rawData.result.value)
                .filter((rawData) => !!rawData)
                .map((rawData) => {
                return this.program.coder.accounts.decode('RoundState', Buffer.from(rawData.data[0], 'base64'));
            });
        });
    }
}
exports.Batch = Batch;
